import React from 'react';

const ButtonBlue = () => {

  return (
    <>
        <button className='form-input-btn blue' type='submit'>
          Generuj Stopkę
        </button>
    </>
  );
};

export default ButtonBlue;